import { render, staticRenderFns } from "./Vinput.vue?vue&type=template&id=dd2107c6&"
import script from "./Vinput.vue?vue&type=script&lang=js&"
export * from "./Vinput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports